import encodedParser from './encoded-parser';
var encodedObjectParser = function (options) {
    if (options === void 0) { options = {}; }
    var _a = options.fallback, fallback = _a === void 0 ? {} : _a, _b = options.strFallback, strFallback = _b === void 0 ? '' : _b;
    var encoded = encodedParser();
    return {
        parse: function (data) {
            try {
                var targetStr = encoded.parse(data) || fallback;
                return JSON.parse(targetStr);
            }
            catch (e) {
                return fallback;
            }
        },
        stringify: function (data) {
            return data ? encoded.stringify(JSON.stringify(data)) || strFallback : strFallback;
        },
    };
};
export default encodedObjectParser;
//# sourceMappingURL=encoded-object-parser.js.map